export default __webpack_public_path__ + "static/media/Karsha-coin-Hindi-font-72ppi.9e677dca.png";